export default {
    methods: {
        watchOnce({ key, callback }) {
            const unwatch = this.$watch(key, (value, oldValue) => {
                callback(value, oldValue, unwatch);
            });
        },
    },
};
